import { DEBUG } from '@src/DEBUG';
DEBUG.open('/xs/xs.module.ts');

import { NgModule } from '@angular/core';

// we're re-using the shared module
import { SharedModule } from '../commons/shared.module';

import { XsIdentityInterface } from './interfaces/identify.interface';
import { XsWidgetPopoverComponent } from './services/ui/widget-popover/widget-popover.component';
import { XsPhotoBucketComponent } from './widgets/photo-bucket/photo-bucket.component';

import { XsSizeableDirective } from './directives/sizeable.directive';
import { XsCameraControllerComponent } from './services/ui/camera-controller/camera-controller.component';
import { XsSplitViewerComponent } from './services/ui/split-viewer/split-viewer.component';

import { TileProfilerComponent } from './services/ui/tile-profiler/tile-profiler.component';

/*

  Short version: All Xs stuff is a rewrite and cleanup of old stuff worth keeping

  At the core of it all sits two properties;
  __ID     = All things identity; classes gets thir own UUID, and id's are create, some introspection
  __EVENTS = All things event participation; subscription, firing, hooks, cleanup, etc.

*/

@NgModule({
  imports: [SharedModule],
  exports: [
    SharedModule,

    // our components
    XsPhotoBucketComponent,
    XsWidgetPopoverComponent,
    XsSplitViewerComponent,
    XsCameraControllerComponent,
    TileProfilerComponent,

    XsSizeableDirective,
  ],

  declarations: [
    XsPhotoBucketComponent,
    XsWidgetPopoverComponent,
    XsSplitViewerComponent,
    XsCameraControllerComponent,
    TileProfilerComponent,

    XsSizeableDirective,
  ],

  providers: [],
})
export class XsModule implements XsIdentityInterface {
  __ID = XsIdentityInterface.__init(this);
}
